<template>
  <div class="records-list">
    <Loading v-if="loading" :background-color="'#ffffff'" :opacity="0.4"/>
    <div v-else-if="expiringPoints.length === 0" class="empty">暫無即將到期點數</div>
    <template v-else-if="useCustomLayout">
      <PointLogItem
        v-for="item in expiringPoints"
        :key="item.id"
        class="s-mb-3"
        :log="item"
        :field-setting="fieldSetting"
      />
    </template>
    <template v-else>
      <PointCard
        v-for="item in expiringPoints"
        :key="item.id"
        :title="getModuleConfig('member_card_section.points_name') || '點數'"
        :date="item.date"
        :date-label="item.date? '到期日期' : '永久有效'"
        :point-need-text="item.point_display"
        :show-type-info="false"
      />
    </template>
  </div>
</template>

<script>
import _ from "lodash";
import pointApi from "@/apis/liff/v2/point";
import { format } from "date-fns";
import Loading from "@/components/Page/Liff/Shared/Loading";
import PointCard from "@/components/Page/Liff/Point/PointCard";
import PointLogItem from "@/components/Page/Liff/Point/PointLogItem";
export default {
  components: {
    Loading,
    PointCard,
    PointLogItem,
  },
  props: {
    eventCode: {
      type: String,
      default: null,
    },
    fieldSetting: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      expiringPointsResponse: null,
      loading: false,
    };
  },
  computed: {
    useCustomLayout() {
      return _.get(this.fieldSetting, "list", []).length > 0;
    },
    expiringPoints() {
      return (this.expiringPointsResponse || [])
        .map(this.mapExpiringPointItem)
        .sort((a, b) => {
          // 1. If both are empty, they are equal
          if (a.date === b.date) return 0;

          // 2. If 'a' is empty, move it to the end (return positive)
          if (a.date === '') return 1;

          // 3. If 'b' is empty, move 'a' to the front (return negative)
          if (b.date === '') return -1;

          // 4. Otherwise, compare strings normally for ascending order
          return a.date.localeCompare(b.date);
        });
    },
  },
  mounted() {
    this.fetchExpiringPoints();
  },
  methods: {
    async fetchExpiringPoints() {
      this.loading = true;
      try {
        this.expiringPointsResponse = await pointApi.getAllExpiringPoints(this.eventCode);
      } catch (error) {
        console.error("Failed to fetch expiring points:", error);
      } finally {
        this.loading = false;
      }
    },
    getModuleConfig(key) {
      return this.$store.getters["liffModule/getConfig"]("liff_point", key);
    },
    mapExpiringPointItem(item, index) {
      const PERMANENT_LABEL = "永久有效";

      const hasExpiry =
        item.expired_at != null && String(item.expired_at).trim() !== "";

      if (hasExpiry) {
        const expiryDate = new Date(item.expired_at);
        return {
          id: `expiring-${index}`,
          point: item.point ?? "",
          point_display: parseInt(item.point || 0).toLocaleString("en-US"),
          point_adjust: item.point ?? "",
          date: format(expiryDate, "yyyy/MM/dd"),
          expired_at: format(expiryDate, "yyyy-MM-dd HH:mm"),
          expired_at_datetime: format(expiryDate, "yyyy-MM-dd HH:mm"),
          expired_at_date: format(expiryDate, "yyyy-MM-dd"),
        };
      }

      return {
        id: `expiring-${index}`,
        point: item.point ?? "",
        point_display: parseInt(item.point || 0).toLocaleString("en-US"),
        point_adjust: item.point ?? "",
        date: "",
        expired_at: PERMANENT_LABEL,
        expired_at_datetime: PERMANENT_LABEL,
        expired_at_date: PERMANENT_LABEL,
      };
    }
  },
};
</script>

<style lang="scss" scoped>
.records-list {
  padding: 12px;
  padding-bottom: 0;
  background: #fff;
}

.loading, .empty {
  text-align: center;
  padding: 40px 20px;
  color: var(--liff-secondary_text_color);
  font-size: 14px;
}
</style>
